// Profile facts the customer screen shows under the name, from the customer
// record the till already loaded (b2c_customer): birthday and anniversary
// (flagged when they fall in the next week), gender, the store they signed
// up at, last visit and visits. Each fact is { key, label, soon? }.
import dayjs from "dayjs";

const SOON_DAYS = 7;
const GENDER = { M: "Male", F: "Female", O: "Other", MALE: "Male", FEMALE: "Female", OTHER: "Other" };

const valid = (d) => {
  if (!d) return null;
  const day = dayjs(d);
  return day.isValid() && day.year() > 1900 ? day : null;
};

// Days from today to the next time this date comes round (0 = today).
export function daysUntil(date, today = dayjs()) {
  const d = valid(date);
  if (!d) return null;
  const start = dayjs(today).startOf("day");
  let next = d.year(start.year()).startOf("day");
  if (next.isBefore(start)) next = next.add(1, "year");
  return next.diff(start, "day");
}

function dateFact(key, name, date, today) {
  const d = valid(date);
  if (!d) return null;
  const days = daysUntil(d, today);
  const soon = days !== null && days < SOON_DAYS;
  const when = days === 0 ? "today" : days === 1 ? "tomorrow" : soon ? `in ${days} days` : null;
  return { key, label: `${name} ${d.format("DD MMM")}${when ? ` · ${when}` : ""}`, soon };
}

export function profileFacts(customer, bunitId, today = dayjs()) {
  if (!customer) return [];
  const gender = GENDER[String(customer.gender || "").trim().toUpperCase()] || null;
  const home = customer.b2cRegisteredstoreId;
  const lastVisit = valid(customer.lastVisitDate);
  const visits = Number(customer.noOfVisits);
  return [
    dateFact("birthday", "Birthday", customer.birthday, today),
    dateFact("anniversary", "Anniversary", customer.anniversaryDate, today),
    gender ? { key: "gender", label: gender } : null,
    home ? { key: "home", label: bunitId && home === bunitId ? "Signed up here" : "Signed up at another store" } : null,
    lastVisit ? { key: "lastVisit", label: `Last visit ${lastVisit.format("DD MMM YYYY")}` } : null,
    Number.isFinite(visits) && visits > 0 ? { key: "visits", label: `${visits} ${visits === 1 ? "visit" : "visits"}` } : null,
  ].filter(Boolean);
}
